import { RetailerSearch } from './components/retailerSearch';

export default function AuroraPage() {
  return <RetailerSearch />;
}
